export default "__VITE_PUBLIC_ASSET__47d445bc__"